import { createContext } from 'react';

const BuildTimestampContext = createContext<number>(0);

const { Provider: BuildTimestampProvider } = BuildTimestampContext;

export { BuildTimestampContext, BuildTimestampProvider };
